(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/selection-summary.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/selection-summary.js');

'use strict';

const BetSummary = svs.racing.betSummary.BetSummary;
const {
  Select,
  Option
} = svs.ui.reactForm;
const Paper = svs.ui.ReactPaper;
const {
  systemTypes
} = svs.racing.common.constants;
const SelectionSummary = _ref => {
  let {
    engine,
    participants
  } = _ref;
  const {
    setReserve
  } = engine.actions;
  const {
    getPositions,
    getReserve,
    getValidReservePositions,
    isPixPick,
    getSingleOnFirstPosition
  } = engine.selectors;
  const {
    systemType,
    gameType,
    hasReserve
  } = engine;
  const reservePositions = getValidReservePositions ? getValidReservePositions() : undefined;
  const hasAvailablePositions = reservePositions ? reservePositions.some(value => value === true) : true;
  const positions = getPositions();
  return React.createElement("div", {
    className: "selection-summary"
  }, React.createElement("div", {
    className: "picker-header"
  }, "Dina h\xE4star"), React.createElement(Paper, {
    branding: "sport"
  }, React.createElement(BetSummary, {
    gameType: gameType,
    isFirstPositionLocked: systemType === systemTypes.TOP_RANK_PIX ? getSingleOnFirstPosition() : false,
    isPixPick: isPixPick,
    positions: positions,
    systemType: systemType
  })), hasReserve && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "picker-header"
  }, "Reserv"), React.createElement("div", {
    className: "reserve-selection"
  }, React.createElement("div", {
    className: "form-v2"
  }, React.createElement(Select, {
    branding: "racing",
    className: "select-reserve",
    onChange: e => {
      const num = Number(e.target.value);
      setReserve(isNaN(num) ? undefined : num);
    },
    value: getReserve() !== undefined ? getReserve().toString() : '-'
  }, React.createElement(Option, {
    disabled: !hasAvailablePositions,
    value: undefined
  }, "Automatiskt"), React.createElement(Option, {
    value: "-1"
  }, "Ingen reserv"), participants.map((value, index) => !participants[index].canceled && React.createElement(Option, {
    disabled: reservePositions ? !reservePositions[index] : false
    ,
    key: index,
    value: index.toString()
  }, "".concat(index + 1, " - ").concat(participants[index].horseName))))))));
};
svs.racing_game.components.play.SelectionSummary = SelectionSummary;

 })(window);